import styles from './styles.module.scss';
import PublicRoutes from '../../routes/publicRoutes';
import logoLgSrc from '../../assets/canguro-lg.svg';
import logoMdSrc from '../../assets/canguro-md.svg';
import { useCountryCodeInterceptor } from '../../../utils/useCountryCodeInterceptor';

const PublicLayout = () => {
  useCountryCodeInterceptor();

  return (
    <div className={styles.container} data-testid="public-layout-test">
      <div className={styles.containerRow}>
        <div className={`${styles.containerCol6} ${styles.logoMd}`}>
          <div>
            <img src={logoMdSrc} alt="" />
          </div>
        </div>
        <div className={`${styles.containerCol5} ${styles.logoLg}`}>
          <div>
            <img src={logoLgSrc} alt="" />
          </div>
        </div>
        <div className={`${styles.containerCol1} ${styles.logoLg}`} />
        <div className={`${styles.containerCol12} ${styles.containerColSm4}`}>
          <PublicRoutes />
        </div>
      </div>
    </div>
  );
};

export default PublicLayout;
